import { Component, Input } from '@angular/core';
import { Terminal } from '../../../../../../@core/domain/interfaces/terminal.interface';

@Component({
  selector: 'app-access-mode',
  templateUrl: './access-mode.component.html',
  styleUrls: ['./access-mode.component.scss'],
})
export class AccessModeComponent {
  @Input()
  terminal!: Terminal;

  constructor() {}
}
